import { render, staticRenderFns } from "./entrust.vue?vue&type=template&id=3f62f385&scoped=true"
import script from "./entrust.vue?vue&type=script&lang=js"
export * from "./entrust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62f385",
  null
  
)

export default component.exports